import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const TrustedBy: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('TrustedBy');
    return (
        <div className={`${styles.TrustedBy} GtmModuleData-section`} data-section-id="TrustedBy">
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="trail-layout">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1752135673664/pc.png"
                    pad="https://websiteoss.ecoflow.com/upload/image/1752135693216/pad.png"
                    h5="https://websiteoss.ecoflow.com/upload/image/1752135673779/h5.png"
                />
            </div>
        </div>
    );
};

export default TrustedBy;
